import { cartApi } from './cartApi';

export const rtkApiMiddleware = [cartApi].map(({ middleware }) => middleware);
